<template>
    <div>
        <b-modal
            id="add-data-segment-popup"
            ref="modal"
            :title="title"
            size="sm"
            hide-footer
            no-close-on-backdrop
            modal-class="hide-footer"
            no-close-on-esc
            :hide-header-close="loading"
            @hidden="onHidden"
        >
            <b-form
                @submit.stop.prevent="onSubmit()"
                @reset.stop.prevent="onHidden"
            >
                <div class="row custom-model-form">
                    <div class="col-md-12">
                        <b-form-group
                            id="input-group-5"
                            label="Segment Type"
                            label-for="dataSegmentType"
                        >
                            <b-form-select
                                v-model="formData.dataSegmentType"
                                v-validate="{
                                    required: true,
                                }"
                                aria-placeholder="Select Type"
                                name="dataSegmentType"
                                :class="['form-control']"
                                :options="dataSegmentTypes"
                            ></b-form-select>
                        </b-form-group>
                    </div>
                    <div class="col-md-12">
                        <b-form-group
                            id="input-group-5"
                            label="Country"
                            label-for="country"
                        >
                            <b-form-select
                                v-model="formData.nationality"
                                v-validate="{
                                    required: true,
                                }"
                                name="country"
                                :class="[
                                    'form-control',
                                    {
                                        'is-invalid': errors.has('country'),
                                    },
                                ]"
                                :options="nationalities"
                            ></b-form-select>
                        </b-form-group>
                    </div>
                    <div class="col-md-12">
                        <b-form-group
                            id="input-group-1"
                            label="Data Segment Title"
                            label-for="segment-title"
                        >
                            <b-form-input
                                id="segment-title"
                                v-model="formData.title"
                                v-validate="{
                                    required: true,
                                    max: 50,
                                    min: 5,
                                }"
                                type="text"
                                name="title"
                                :class="{
                                    'is-invalid': errors.has('title'),
                                }"
                                autocomplete="no"
                                placeholder="Enter data segment title"
                            ></b-form-input>
                        </b-form-group>
                    </div>
                    <div class="col-md-12">
                        <b-form-group
                            id="input-group-2"
                            label="Data Segment Code"
                            label-for="segment-code"
                        >
                            <b-form-input
                                id="segment-code"
                                v-model="formData.code"
                                v-validate="{
                                    required: true,
                                    max: 3,
                                    min: 1,
                                }"
                                type="text"
                                name="code"
                                :class="{
                                    'is-invalid': errors.has('code'),
                                }"
                                autocomplete="no"
                                placeholder="Enter data segment code (max 3 characters)"
                            ></b-form-input>
                        </b-form-group>
                    </div>
                    <div v-if="advMedia" class="col-md-12">
                        <b-form-group
                            id="allowAdvMedia"
                            label="Allow Adverse Media Search"
                            label-for="allowAdvMedia"
                        >
                            <b-form-radio-group
                                v-model="formData.allowAdvMedia"
                                autocomplete="no"
                                :disabled="loading"
                                :options="radioOptions"
                                :text-field="textField"
                                :value-field="valueField"
                                data-vv-name="Adverse Media Search"
                                :class="{
                                    'is-invalid': errors.has(
                                        'Adverse Media Search'
                                    ),
                                }"
                            >
                            </b-form-radio-group>
                        </b-form-group>
                    </div>
                    <div v-if="pep" class="col-md-12">
                        <b-form-group
                            id="allowPepSearch"
                            label="Allow PEP Search"
                            label-for="allowPepSearch"
                        >
                            <b-form-radio-group
                                v-model="formData.allowPepSearch"
                                autocomplete="no"
                                :disabled="loading"
                                :options="radioOptions"
                                :text-field="textField"
                                :value-field="valueField"
                                data-vv-name="PEP Search"
                                :class="{
                                    'is-invalid': errors.has('PEP Search'),
                                }"
                            >
                                <!-- <option slot="first" :value="null" disabled>
                                    {{ onboardingType.placeholder }}
                                </option> -->
                            </b-form-radio-group>
                        </b-form-group>
                    </div>
                    <div class="col-md-12">
                        <b-form-group
                            id="isQADatasegment"
                            label="Testing DataSegment ?"
                            label-for="isQADatasegment"
                        >
                            <b-form-radio-group
                                v-model="formData.isQADatasegment"
                                autocomplete="no"
                                :disabled="loading"
                                :options="radioOptions"
                                :text-field="textField"
                                :value-field="valueField"
                                data-vv-name="Adverse Media Search"
                                :class="{
                                    'is-invalid': errors.has(
                                        'Adverse Media Search'
                                    ),
                                }"
                            >
                            </b-form-radio-group>
                        </b-form-group>
                    </div>
                     <div class="col-md-12">
                         <b-form-group
                             id="input-group-5"
                             class="mb-0 kyc-status-radio overwrite-radio"
                             label="Enable Delta Screening"
                             label-for="DeltaScreening"
                         >
                             <b-form-group>
                                 <b-form-radio-group
                                     v-model="formData.deltaScreening"
                                     v-validate="{
                                         required: true,
                                     }"
                                     :options="boolVal"
                                     name="deltaScreening"
                                     :class="{
                                         'is-invalid': errors.has('deltaScreening'),
                                     }"
                                 ></b-form-radio-group>
                             </b-form-group>
                         </b-form-group>
                        </div>
                    <div class="col-md-12 action-buttons">
                        <base-button
                            :btn-label="buttonLabel"
                            btn-type="submit"
                            btn-variant="primary"
                            :class="loading ? 'disabled' : ''"
                        ></base-button>
                        <base-button
                            btn-label="Cancel"
                            btn-type="reset"
                            btn-variant="link"
                        ></base-button>
                    </div>
                </div>
            </b-form>
            <base-toast></base-toast>
        </b-modal>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
    /*
    |--------------------------------------------------------------------------
    | Component > props
    |--------------------------------------------------------------------------
    */
    props: {}, // End of Component > props
    /*
    |--------------------------------------------------------------------------
    | Component > data
    |--------------------------------------------------------------------------
    */
    data() {
        return {
            formData: this.initializeFormData(),
             boolVal: [
                 { text: 'Yes', value: true },
                 { text: 'No', value: false },
             ],
            dataSegmentTypes: [
                { value: null, text: 'Select Type', disabled: true },
                'Corporate',
                'Individual',
            ],
            textField: 'text',
            valueField: 'value',
            radioOptions: [
                { text: 'Yes', value: true },
                { text: 'No', value: false },
            ],
            advMedia:
                process.env.VUE_APP_ADVERSE_MEDIA_SEARCH == 'true'
                    ? true
                    : false,
            pep: process.env.VUE_APP_PEP_SEARCH == 'true' ? true : false,
        }
    },
    /*
    |--------------------------------------------------------------------------
    | Component > computed
    |--------------------------------------------------------------------------
    */
    computed: {
        ...mapGetters([
            'loading',
            'selectedItem',
            'hidePopup',
            'nationalities',
        ]),
        title() {
            return this.selectedItem
                ? 'Modify Data Segment'
                : 'Add Data Segment'
        }, // End of title() method

        buttonLabel() {
            return this.selectedItem ? 'Update' : 'Create'
        },
    }, // End of Component > computed
    /*
    |--------------------------------------------------------------------------
    | Component > watch
    |--------------------------------------------------------------------------
    */
    watch: {
        /**
         * Handle when the selected has been updated
         *
         * @return {void}
         */
        selectedItem(value) {
            console.log('value selected item:', value)
            if (value !== null && value !== undefined) {
                this.formData.id = value._id
                this.formData.title = value.title
                this.formData.code = value.code
                this.formData.nationality = value.nationality
                    ? value.nationality.title
                    : null
                this.formData.deltaScreening = value.deltaScreening
                this.formData.dataSegmentType = value.type ? value.type : null
                this.formData.allowAdvMedia = value.allowAdvMedia
                this.formData.allowPepSearch = value.allowPepSearch
                this.formData.isQADatasegment = value.isQADatasegment
            } else if (this.$refs.modal._isShown) {
                this.$refs.modal.hide()
            } else {
                this.onHidden()
            }
        },
        /**
         * Handle when popup hides
         *
         * @return {void}
         */
        hidePopup(value) {
            if (value) {
                this.onHidden()
            }
        },
    }, // End of Component > watch
    /*
    |--------------------------------------------------------------------------
    | Component > mounted
    |--------------------------------------------------------------------------
    */
    mounted() {
        console.log('adv media, pep: ', this.advMedia, this.pep)
    }, // End of mounted
    methods: {
        //initialize form data
        initializeFormData() {
            return {
                id: null,
                title: '',
                code: '',
                dataSegmentType: '',
                nationality: null,
                deltaScreening: null,
                allowAdvMedia: true,
                allowPepSearch: false,
                isQADatasegment: false,
            }
        },

        async onSubmit() {
            const result = await this.$validator.validateAll()
            if (result) {
                try {
                    if (this.formData.id) {
                        //update application access
                        await this.$store.dispatch(
                            'updateDataSegment',
                            this.formData
                        )
                    } else {
                        //add application access
                        await this.$store.dispatch(
                            'addDataSegment',
                            this.formData
                        )
                        // Clear form fields
                    }
                } catch (error) {
                    console.log(error, 'There is an error on submit')
                }
            } else {
                this.$store.commit('setError', this.errors.all()[0])
            }
        },
        /**
         * Handle when the modal is closed
         *
         * @return {void}
         */
        onHidden() {
            // clear the selected item
            this.$store.commit('clearItem')
            Object.assign(this.formData, this.initializeFormData())
            this.$validator.reset()
            this.$refs.modal.hide()
        }, // End of onHidden() method
    },
}
</script>
